<template>
    <div class="container pb-4">
        <div class="row pt-5 ">
            <div class="col-md col-sm-12 p-1" v-for="item in opciones" :key="item.label">
                <router-link :to="{name:item.route}" tag="button" active-class="active" class="btn btn-outline-brand btn-elevate btn-square btn-block">
                    {{item.label}}
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
    import constantes from "../constantes";

    export default {
        name: "menu-usuario",
        data:()=>({
            opciones:constantes.Constantes.menu
        })
    }
</script>

<style scoped>

</style>
